import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { S_WebButtonSmaller } from 'elements/button/WebButton';
import { ImageMask } from 'elements/visual/ImageMask';
import { motion } from 'framer-motion';
import { ANIMATION_APPEAR, conditionalScaleAnimation } from 'libs/styles/animations';
import { EColors, EFonts, EGrads, EShadows } from 'libs/styles/styling';
import { useState } from 'react';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    onContinue: (name: string) => void;
    className?: string;
}

export const CreateMinuteStart = (props: Props): JSX.Element => {
    const [value, setValue] = useState<string>('');
    const [agree, setAgree] = useState<boolean>(false);

    return (
        <S_CreateMinuteStart
            className={props.className}
            {...ANIMATION_APPEAR}
            {...conditionalScaleAnimation(true, 1.05, 1.05)}
        >
            <S_Content>
                <S_Input
                    type="text"
                    placeholder={Localization.NAME_YOUR_MAP}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                />
                <S_Agree>
                    <S_Check onClick={() => setAgree(!agree)}>
                        {agree && <S_Checked icon={['fas', 'circle-check']} />}
                    </S_Check>
                    <S_AgreeText onClick={() => setAgree(!agree)}>
                        {Localization.AGREE_WITH}{' '}
                        <a href="/terms" target="_blank">
                            {Localization.TERMS_AND_CONDITIONS?.charAt(0).toUpperCase() +
                                Localization.TERMS_AND_CONDITIONS?.slice(1)}
                        </a>
                    </S_AgreeText>
                </S_Agree>
                <S_Center>
                    <S_WebButton
                        shadow={EShadows.LIGHT}
                        disabled={!value || !agree}
                        type={'primary'}
                        text={Localization.CREATE_YOUR_MAP}
                        onClick={() => {
                            if (value && agree) props.onContinue(value);
                        }}
                    />
                </S_Center>
            </S_Content>
            <ImageMask randomizePosition={true} step={20} image="contour" repeat={true} />
        </S_CreateMinuteStart>
    );
};

const S_CreateMinuteStart = styled(motion.div)`
    width: 100%;
    border-radius: 7px;
    position: relative;
    padding: 20px 30px;
    background: ${EGrads.ACC2_GRAD};
    box-shadow: ${EShadows.STRONG};
    @media only screen and (min-width: 1260px) {
        width: 430px;
    }
`;

const S_Content = styled.div`
    z-index: 1;
`;

const S_Input = styled.input`
    width: 100%;
    margin: 10px 0 0 0;
    padding: 15px 20px;
    border-radius: 7px;
    border: 1px solid #8286a2;
    font-size: 14px;
    box-sizing: border-box;
    ::placeholder {
        color: ${EColors.GREY};
        font-style: normal;
    }
`;

const S_Check = styled.div`
    margin: 0 15px 0 0;
    width: 28px;
    height: 28px;
    cursor: pointer;
    border-radius: 50%;
    border: 1px solid #8286a2;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
`;

const S_Checked = styled(FontAwesomeIcon)`
    font-size: 23px;
    color: ${EColors.DARK};
`;

const S_Agree = styled.div`
    display: flex;
    align-items: center;
    margin: 20px 0 20px 0;
`;

const S_AgreeText = styled.div`
    color: white;
    font-size: 15px;
    font-family: ${EFonts.Regular};
    a {
        color: white;
        text-decoration: underline;
        &:hover {
            text-decoration: none;
        }
    }
`;

const S_Center = styled.div`
    display: flex;
    justify-content: center;
`;

const S_WebButton = styled(S_WebButtonSmaller)`
    margin: 0 0 15px 0;
`;
